/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2018/12/14 10:32
 * @des   一些只兼容某一平台的处理代码
 */

import {t} from '@/base/i18n'

/**
 * 设置浏览器网页标题
 */
export function setTitle (title) {
  let appName = t('common_common.appName')
  appName = appName ? appName : '小雨优学'//兼容没有支持国际化的页面
  document.title = `${title && title != '' ? title + ' - ' : ''}${appName}`
}



// WEBPACK FOOTER //
// ./src/base/util/compatible.js